/*
Plywood

--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>
--weight <float> | lbs/sqft | (per sheet, by lbs/sqft)
--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import { decimal } from 'vuelidate/lib/validators'
import { fireRated, moistureResistant, manufacturers, sheetStockFormFields } from '@/modules/standardItems/schemas/sheetStock/form'

export default [
  ...sheetStockFormFields(),
  {
    key: 'type',
    value: 'type',
    type: 'select',
    required: true,
    default: 'Poplar',
    classes: ['xs12', 'sm8'],
    attributes: {
      label: 'Type',
      required: true,
      class: ['input--dense']
    },
    values: ['Poplar', 'Baltic Birch', 'Birch', 'Luan']
  },
  fireRated({ classes: ['xs12', 'sm4', 'input__wrapper'] }),
  moistureResistant({ classes: ['xs12', 'sm4', 'input__wrapper'] }),
  {
    key: 'weight',
    value: 'weight',
    type: 'float',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Weight',
      suffix: 'lbs/sqft',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'Weight should be a number'
      }
    ]
  },

  manufacturers()
]
